const FLASH_KEY = "auth_flash_message";
const REDIRECT_KEY = "auth_redirect_in_progress";
const DEFAULT_SESSION_MESSAGE = "Your login session expired. Please sign in again.";

function getSessionStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function consumeAuthFlashMessage() {
  const storage = getSessionStorage();
  if (!storage) return null;

  const message = storage.getItem(FLASH_KEY);
  storage.removeItem(FLASH_KEY);
  storage.removeItem(REDIRECT_KEY);
  return message;
}

export function handleSessionExpired({
  storageKeys = [],
  loginPath,
  message = DEFAULT_SESSION_MESSAGE,
}) {
  if (typeof window === "undefined") return false;

  const storage = getSessionStorage();
  if (storage?.getItem(REDIRECT_KEY)) return true;

  storageKeys.forEach((key) => localStorage.removeItem(key));

  if (storage) {
    storage.setItem(FLASH_KEY, message);
    storage.setItem(REDIRECT_KEY, "1");
  }

  if (window.location.pathname !== loginPath) {
    window.location.assign(loginPath);
  }

  return true;
}

export function isAuthEndpoint(url = "") {
  return /\/(login|logout|refresh|register-start|verify-email|set-password|forgot|reset)/i.test(url);
}
